// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__aNwhl","shadowed2":"Home_shadowed2__etGt7","icons":"Home_icons__qjMbq","photo":"Home_photo__t1j8p"};